import { r as i, h as e } from "./index-6e735f92.js";
import "react";
import "react/jsx-runtime";
import "react-dom";
const n = ".sc-underline-icon-h{display:flex}", r = n, o = class {
  constructor(t) {
    i(this, t), this.width = "15", this.height = "15";
  }
  render() {
    return e("svg", { key: "dc0483110aa9891913441e60edaa760fc4a6c47f", width: this.width, height: this.height, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, e("path", { key: "0e5296b050aa8dd3a71e4d68ce9e5e21bee37766", d: "M19 4V10C19 13.866 15.866 17 12 17C8.13401 17 5 13.866 5 10V4M8.5 4V10C8.5 13.2218 10.6766 15.9352 13.6395 16.7501M4 21H20M3 4L10.5 4M17 4L21 4", stroke: "currentColor", "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }));
  }
};
o.style = r;
export {
  o as underline_icon
};
